__turbopack_context__.v({
  "list": "PerformerNamesList-module-scss-module__HdPS8W__list",
});
